import Translator from '../Translator';

import abbLogo from '../../assets/partners/ABB.png';
import brLogo from '../../assets/partners/B&R.png';
import siemensLogo from '../../assets/partners/Siemens.png';
import rockweellLogo from '../../assets/partners/Rockwell_Automation.png';

import { Title, Logo, Content, TitleBorderBottomContainer, TitleBorderBottom } from './style';

export default function Partners() {
  return (
    <>
      <Title id="partners">
        <h2>
          <Translator path={'partners.title'} />
        </h2>
      </Title>

      <TitleBorderBottomContainer>
        <TitleBorderBottom />
      </TitleBorderBottomContainer>

      <Content>
        <Logo src={abbLogo} height={70} />
        <Logo src={brLogo} height={60} />
        <Logo src={siemensLogo} height={80} />
        <Logo src={rockweellLogo} height={60} />
      </Content>
    </>
  );
}
